import CELL_DATA_TYPES from '../cell-types.config';
import { ACTIONS } from '../const.config';

// Videos module configurations
export const LISTING_COLUMNS = [
  {
    id: 'name',
    label: 'Title',
    align: 'left',
    dataKey: 'title',
    sortable: true,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'seasonNumber',
    label: 'Season Number',
    width: '5%',
    align: 'left',
    dataKey: 'number',
    sortable: true,
    type: CELL_DATA_TYPES.NUMBER,
  },
  {
    id: 'series',
    label: 'Series',
    width: '10%',
    align: 'left',
    dataKey: 'seriesTitle',
    sortable: false,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'episodes',
    label: 'Number of Episodes',
    width: '10%',
    align: 'left',
    dataKey: 'episodeCount',
    sortable: false,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'status',
    label: 'Status',
    align: 'center',
    dataKey: 'status',
    sortable: true,
    type: CELL_DATA_TYPES.SWITCH,
  },
  {
    id: 'createdAt',
    label: 'Created At',
    width: '15%',
    align: 'left',
    dataKey: 'createdAt',
    sortable: true,
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
  {
    id: 'modifiedAt',
    label: 'Modified Date',
    width: '15%',
    align: 'center',
    dataKey: 'modifiedAt',
    sortable: true,
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
];

export const LISTING_ACTIONS = [
  {
    action: ACTIONS.EDIT.value,
    label: ACTIONS.EDIT.label,
  },
  {
    action: ACTIONS.VIEW.value,
    label: ACTIONS.VIEW.label,
  },
  {
    action: ACTIONS.VIEW_EPISODES.value,
    label: ACTIONS.VIEW_EPISODES.label,
  },
  {
    action: ACTIONS.SEQUENCE.value,
    label: ACTIONS.SEQUENCE.label,
    conditional: (val) => Number(val.episodeCount) > 1,
  },
  {
    action: ACTIONS.DELETE.value,
    label: ACTIONS.DELETE.label,
  },
];

export const VIEW_COLUMNS = [
  {
    id: 'name',
    label: 'Title',
    dataKey: 'title',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'seasonNumber',
    label: 'Season Number',
    dataKey: 'number',
    type: CELL_DATA_TYPES.NUMBER,
  },
  {
    id: 'series',
    label: 'Series',
    dataKey: 'series',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'status',
    label: 'Status',
    dataKey: 'status',
    type: CELL_DATA_TYPES.STATUS,
  },
  {
    id: 'createdAt',
    label: 'Created At',
    dataKey: 'createdAt',
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
  {
    id: 'modifiedAt',
    label: 'Modified At',
    dataKey: 'modifiedAt',
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
];
